import React from "react";
import Banner from "../../../Assets/Common/banner-1.webp";

const SimpleBanner = ({
  backgroundImage = Banner,
  title = "",
  subheading = "",
}) => {
  const isVideo = backgroundImage?.endsWith(".mp4");

  return (
    <div className="relative w-full h-[150px] sm:h-[200px] md:h-[250px] lg:h-[300px] overflow-hidden">
      {/* Background Media */}
      {isVideo ? (
        <video
          src={backgroundImage}
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        />
      ) : (
        <img
          src={backgroundImage}
          alt="Main Banner"
          className="absolute inset-0 w-full h-full object-cover object-left-top"
          loading="lazy"
        />
      )}

      {/* Dark Overlay for readability */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Content */}
      <div className="relative z-10 font-josefin flex items-center justify-center h-full px-4 sm:px-6 text-center">
        <div className="max-w-[1200px]">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
            {title}
          </h1>

          {subheading && (
            <p className="mt-3 text-sm sm:text-base md:text-lg text-white/90">
              {subheading}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SimpleBanner;
